import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
import config from "./config";
class Logger {
    constructor() {
        this.appInsights = null;
    }
    init() {
        try {
            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: config.aiConnectionString,
                    disablePageUnloadEvents: ["unload"],
                }
            });
            this.appInsights.loadAppInsights();
        }
        catch (e) {
            console.error(e);
        }
    }
    error(err) {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackException(err);
    }
    warn(message) {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackTrace({
            message,
            severityLevel: SeverityLevel.Warning,
        });
    }
    pageView() {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackPageView();
    }
}
const logger = new Logger();
logger.init();
export default logger;
